/* # =================================================================
# ハンバーガーアイコンをスクロールしたらフェードインする時に使用
# ================================================================= */

export default function hamburgerFadeIn() {
	const fade_icon = document.getElementById("hamburger-icon");
	const display = document.getElementById("hamburger-display");
  var scrollTop = window.scrollY || document.documentElement.scrollTop;

  window.addEventListener('scroll', function () {
    if (scrollTop > 150) {
      fade_icon.style.display = "flex";
    } else {
      if (!fade_icon.classList.contains('js-click-hamburger') && window.innerWidth >= 1280) {
        fade_icon.style.display = "none"
      }
    }
  });
}
